<template>
<div class="card">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
    <div class="card-header">
        <p class="card-header-title">Add Form</p>
    </div>
    <div class="card-content">
        <div class="columns">
            <div class="column is-5">
                <div class="field">
                    <label class="label">Form Name</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="e.g Visitor's Form" v-model="name">
                    </div>
                </div>
            </div>

            <div class="column is-4">
                <div class="field">
                    <label class="label">Number of fields (max 20)</label>
                    <div class="control">
                        <input class="input" type="number" placeholder="1 - 20" v-model="fieldCount" @change="updateFieldCount()" @click="updateFieldCount()">
                    </div>
                </div>
            </div>

            <div class="column is-3">
                <div class="field">
                    <label class="label">Status</label>
                    <div class="control">
                        <label class="radio">
                            <input type="radio" :name="formStatus" v-model="formStatus" value="1" checked>
                            Active
                        </label>
                        <label class="radio">
                            <input type="radio" :name="formStatus" v-model="formStatus" value="0">
                            Inactive
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-full">
            <div class="field" v-for="myFields in listOfMyFields" :key="myFields.id">
                <div class="columns">
                    <div class="column is-one-third">
                        <label class="label">Field name:</label>
                        <div class="control"><input class="input" type="text" placeholder="" name="fieldName" v-model="myFields.fieldName"></div>
                    </div>
                    <div class="column">
                        <label class="label">Field type:</label>
                        <div class="control"><b-select name="fieldType" v-model="myFields.fieldType"><option selected value="1">Text field</option></b-select></div>
                    </div>
                    <div class="column">
                        <label class="label">Required?</label>
                        <div class="control"><b-select name="fieldRequired" v-model="myFields.fieldRequired"><option selected value="1">Yes</option><option selected value="2">No</option></b-select></div>
                    </div>
                    <div class="column is-one-third">
                        <label class="label">Info to display:</label>
                        <div class="control"><input class="input" type="text" placeholder="" name="fieldInfo" v-model="myFields.fieldInfo"></div>
                    </div>
                </div>
            </div>
            <div class="field">
                <label class="label">&nbsp;</label>
                <div class='ui two buttons'>
                    <button class='button is-primary' v-on:click="sendForm()">
                        Create
                    </button>
                </div>
                <loading :active.sync="isLoading" 
                    :can-cancel="false" 
                    :is-full-page="true">
                </loading>
            </div>
        </div>
        
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "ManageFormsAdd",
    components:{
        Loading,
    },
    data() {
        return {
            name: '',
            fieldCount: 0,
            formStatus: "1",
            isLoading: false,
            myFieldsLength: 0,
            listOfMyFields: [],
        };
    },
    created() {
    },
    methods: {        
        updateFieldCount(){
            console.log("masuk updateFieldCount dengan: " + this.fieldCount)
            this.myFieldsLength = this.fieldCount   //strangely, line ni kena ada dekat sini dengan dekat atas (tapi dah hidden kan), kalau tak number of fields tak sync dgn dlm input

            this.listOfMyFields = []

            for (var i = 0; i < this.fieldCount; i++){
                var newObject = {
                    id: i,
                    name: 'field_' + i,
                    fieldType: 1,
                    fieldRequired: 1
                }
                this.listOfMyFields.push(newObject)
            }
            console.log("this.listOfMyFields.length: " + this.listOfMyFields.length)


        },
        sendForm() {
            let self = this;
            console.log("imini 81 " + this.name)
            console.log("imini listOfMyFields.length" + this.listOfMyFields.length)
            console.log(this.listOfMyFields)

            var formName = this.name;
            var formStatus = this.formStatus;
            var fieldCount = this.fieldCount;

            if (formName.length < 2){
                Toast.open({
                    message: "Please enter the form's name!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            if (fieldCount < 1){
                Toast.open({
                    message: "Please enter at least 1 field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            if (fieldCount > 20){
                Toast.open({
                    message: "Please enter no more than 20 fields!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            for (var i = 0; i < this.listOfMyFields.length; i++){
                var fieldName = this.listOfMyFields[i].fieldName
                if ((fieldName == undefined) || (fieldName.length < 1)){                    
                    Toast.open({
                        message: "Please enter the field " + (i + 1) + "'s name!",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }

            if ((formStatus == "0") || (formStatus == "1")){
                
                this.$emit('create-data');
                self.isLoading = true;

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('newToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.NEW_ENDPOINT + '/form/create', {
                        loginEmail: localStorage.getItem('email'),
                        token: localStorage.getItem('newToken'),
                        schoolId: localStorage.getItem('schoolID'),
                        schoolNo: localStorage.getItem('schoolNo'),
                        country: localStorage.getItem('country'),
                        formName: formName,
                        formStatus: formStatus,
                        formFields: this.listOfMyFields
                    })
                    .then(response => {
                        self.isLoading = false
                        if (response.data.success == false){
                            Toast.open({
                                message: 'Error: ' + response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                        }else{
                            Toast.open({
                                message: 'Form successfully added!',
                                type: 'is-success', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 3000
                            })
                            this.$parent.getData()
                            self.name = ""
                            self.fieldCount = 0                            
                        }
                    })
                    .catch(e => {
                        self.isLoading = false;
                        console.log("error")
                        console.log(e.response)
                        if (e.response.status === 401) {                            
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })

                            console.log("salah login")
                            this.errors.push("Invalid login")
                        } else {
                            Toast.open({
                                message: 'Error: ' + e,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                            this.errors.push(e)
                        }
                    })                

            }else{
                Toast.open({
                    message: "Please select the form's status!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
                return false;
            }
        },
    },
};
</script>
<style scoped>
.myLabel{
    float: left;
    width: 15%;
    padding: 5px;
}
.myInput{
    float: left;
    width: 80%;
    padding: 5px;
}
.vertical-center{
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/Forms/AddContent.vue